import { render, staticRenderFns } from "./UserActivityManaged.vue?vue&type=template&id=0b40b096&scoped=true"
import script from "./UserActivityManaged.vue?vue&type=script&lang=js"
export * from "./UserActivityManaged.vue?vue&type=script&lang=js"
import style0 from "./UserActivityManaged.vue?vue&type=style&index=0&id=0b40b096&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b40b096",
  null
  
)

export default component.exports